module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/particular04-e9d719c29261884fc856b0635b05a153.png";